import type { CountryRequiresWhatsappStatus } from './country-requires-whatsapp.model';

export interface GenerateCountryRequiresWhatsappOptions {
  readonly id: string;
  readonly countryRequiresWhatsapp: boolean;
}

export function generateCountryRequiresWhatsappObject({
  id = 'PH',
  countryRequiresWhatsapp = true,
}: GenerateCountryRequiresWhatsappOptions): CountryRequiresWhatsappStatus {
  return {
    id,
    countryRequiresWhatsapp,
  };
}
